import { Currencies, Languages } from "@ribondao/shared/types";

export function coinByLanguage(language: Languages) {
  if (language === Languages.PT) return Currencies.BRL;

  return Currencies.USD;
}
